"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _alignments = require("rich-text-lib/constants/alignments");

var _FileManager = _interopRequireDefault(require("composer-lib/components/shared/FileManager"));

var _draftJs = require("draft-js");

var _Drawer = _interopRequireDefault(require("FileManagerLib/components/Drawer"));

var _Constants = require("FileManagerLib/Constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _pick = _interopRequireDefault(require("transmute/pick"));

var _EditImagePopoverBranch = _interopRequireDefault(require("rich-text-lib/components/image/EditImagePopoverBranch"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("composer-plugins/lib/constants");

var _withLinkCache = _interopRequireDefault(require("rich-text-lib/components/hoc/withLinkCache"));

var _staticUrl = require("rich-text-lib/utils/staticUrl");

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _popover = require("rich-text-lib/constants/popover");

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _userInfo = require("hub-http/userInfo");

var _FilesManager = require("composer-lib/data/FilesManager");

var _PagesManager = require("composer-lib/data/PagesManager");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _EventBoundaryPopover = _interopRequireDefault(require("draft-plugins/components/EventBoundaryPopover"));

var _ALIGNMENT_TO_CLASSNA;

var ALIGNMENT_TO_CLASSNAME = (_ALIGNMENT_TO_CLASSNA = {}, (0, _defineProperty2.default)(_ALIGNMENT_TO_CLASSNA, _alignments.Alignments.NONE, 'align-none'), (0, _defineProperty2.default)(_ALIGNMENT_TO_CLASSNA, _alignments.Alignments.CENTER, 'align-center'), (0, _defineProperty2.default)(_ALIGNMENT_TO_CLASSNA, _alignments.Alignments.LEFT, 'align-left'), (0, _defineProperty2.default)(_ALIGNMENT_TO_CLASSNA, _alignments.Alignments.RIGHT, 'align-right'), _ALIGNMENT_TO_CLASSNA);
var DEFAULT_LINK_DATA = {
  externalLink: true,
  href: null,
  noFollow: false
};
var AdvancedImage = (0, _createReactClass.default)({
  displayName: "AdvancedImage",
  propTypes: {
    block: _propTypes.default.object.isRequired,
    blockProps: _propTypes.default.object.isRequired,
    cache: _propTypes.default.object.isRequired,
    contentState: _propTypes.default.object.isRequired,
    selection: _propTypes.default.object.isRequired,
    updateCache: _propTypes.default.func.isRequired
  },
  contextTypes: {
    getEditorState: _propTypes.default.func.isRequired,
    getReadOnly: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    var _this$props$block$get = this.props.block.getData().toJS(),
        alignment = _this$props$block$get.alignment,
        name = _this$props$block$get.name,
        linkData = _this$props$block$get.linkData,
        src = _this$props$block$get.src;

    return {
      alignment: alignment || _alignments.Alignments.NONE,
      fileManagerMode: null,
      linkData: linkData || DEFAULT_LINK_DATA,
      name: name,
      naturalWidth: 0,
      naturalHeight: 0,
      popoverMode: _popover.PopoverBodyMode.PREVIEW,
      src: src
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var blockProps = this.props.blockProps;
    this.debouncedUpdateBlockData = (0, _debounce.default)(300, this.updateBlockData);
    this.FileManager = (0, _FileManager.default)(blockProps.fileManagerUploadedFileAccess, (0, _UsageTracking.getUsageTracker)());
    this.filePickerCallback = null;
  },
  isSelected: function isSelected() {
    var _this$props = this.props,
        selection = _this$props.selection,
        block = _this$props.block;
    return selection.getStartKey() === block.key && selection.getEndKey() === block.key && !selection.getHasFocus() // if the editor has focus, our popover doesn't, so close it
    ;
  },
  fetchFileByUrl: function fetchFileByUrl(href) {
    return (0, _FilesManager.fetchFileByUrl)(href);
  },
  fetchPageBySlug: function fetchPageBySlug(slug) {
    return (0, _PagesManager.fetchPageBySlug)(slug);
  },
  fetchPagesByTerm: function fetchPagesByTerm(term, offset) {
    return (0, _PagesManager.fetchPagesByTerm)(term, offset);
  },
  forceSelectionOfImageBlock: function forceSelectionOfImageBlock() {
    var key = this.props.block.key;
    var _this$context = this.context,
        getEditorState = _this$context.getEditorState,
        onChange = _this$context.onChange;
    window.getSelection().removeAllRanges();

    var selectionState = _draftJs.SelectionState.createEmpty(key);

    onChange(_draftJs.EditorState.forceSelection(getEditorState(), selectionState));
  },
  updateBlockData: function updateBlockData(newData) {
    var editorState = this.context.getEditorState();
    var selectionState = editorState.getSelection();

    var contentStateWithNewBlockData = _draftJs.Modifier.mergeBlockData(editorState.getCurrentContent(), selectionState, new _immutable.Map((0, _pick.default)(['alignment', 'linkData', 'name', 'src'], newData)));

    this.context.onChange(_draftJs.EditorState.push(editorState, contentStateWithNewBlockData, 'change-block-data'));
  },
  handlePopoverModeChange: function handlePopoverModeChange(newMode) {
    this.setState({
      popoverMode: newMode
    });
  },
  handleImageLoad: function handleImageLoad(event) {
    var onInsertableLoaded = this.props.blockProps.onInsertableLoaded;
    var _event$target = event.target,
        naturalWidth = _event$target.naturalWidth,
        naturalHeight = _event$target.naturalHeight;
    this.setState({
      naturalWidth: naturalWidth,
      naturalHeight: naturalHeight
    });
    onInsertableLoaded(event);
  },
  handleRemoveImage: function handleRemoveImage() {
    var editorState = this.context.getEditorState();
    var newEditorState = (0, _draftHelpers.deleteImageBlock)(editorState);
    this.context.onChange(newEditorState);
  },
  handleImageReplace: function handleImageReplace(file) {
    var updateData = {
      name: file.get('name'),
      src: file.get('url')
    };
    this.setState(updateData);
    this.updateBlockData(updateData);
    this.handleFileManagerClose();
  },
  handleAltTextChange: function handleAltTextChange(altText) {
    this.setState({
      name: altText
    });
    this.debouncedUpdateBlockData({
      name: altText
    });
  },
  handleAlignmentChange: function handleAlignmentChange(alignment) {
    this.setState({
      alignment: alignment
    });
    this.updateBlockData({
      alignment: alignment
    });
  },
  handleLinkDataUpdate: function handleLinkDataUpdate(linkData) {
    this.setState({
      linkData: linkData
    });
    this.debouncedUpdateBlockData({
      linkData: linkData
    });
  },
  handleLinkTypeChange: function handleLinkTypeChange(linkType) {
    var linkData = Object.assign({
      linkType: linkType
    }, DEFAULT_LINK_DATA);
    this.setState({
      linkData: linkData
    });
    this.debouncedUpdateBlockData({
      linkData: linkData
    });
  },
  handleFileSelect: function handleFileSelect(file) {
    if (!this.filePickerCallback) {
      return;
    }

    this.filePickerCallback(file.toJS());
    this.handleFileManagerClose();
  },
  handleFileManagerClose: function handleFileManagerClose() {
    this.filePickerCallback = null;
    this.setState({
      fileManagerMode: null
    });
  },
  handleOpenImagePicker: function handleOpenImagePicker() {
    this.setState({
      fileManagerMode: _Constants.DrawerTypes.IMAGE
    });
  },
  handleOpenFilePicker: function handleOpenFilePicker(callback) {
    this.filePickerCallback = callback;
    this.setState({
      fileManagerMode: _Constants.DrawerTypes.FILE
    });
  },
  getPopoverPlacement: function getPopoverPlacement() {
    var popoverMode = this.state.popoverMode;

    switch (popoverMode) {
      case _popover.PopoverBodyMode.PREVIEW:
        return 'top';

      case _popover.PopoverBodyMode.EDIT:
        return 'right bottom';

      default:
        return '';
    }
  },
  renderFileManager: function renderFileManager(auth) {
    var fileManagerMode = this.state.fileManagerMode;

    if (!fileManagerMode) {
      return null;
    }

    var props = {
      onClose: this.handleFileManagerClose,
      type: fileManagerMode
    };

    switch (fileManagerMode) {
      case _Constants.DrawerTypes.IMAGE:
        props.onSelect = this.handleImageReplace;
        break;

      case _Constants.DrawerTypes.FILE:
        props.onSelect = this.handleFileSelect;
        break;

      default:
        break;
    }

    return _react.default.createElement(this.FileManager, {
      auth: auth
    }, _react.default.createElement(_Drawer.default, props));
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        cache = _this$props2.cache,
        updateCache = _this$props2.updateCache;
    var _this$state = this.state,
        alignment = _this$state.alignment,
        linkData = _this$state.linkData,
        name = _this$state.name,
        naturalWidth = _this$state.naturalWidth,
        naturalHeight = _this$state.naturalHeight,
        popoverMode = _this$state.popoverMode,
        src = _this$state.src;
    var externalLink = linkData.externalLink,
        href = linkData.href,
        linkDisplayName = linkData.linkDisplayName,
        linkType = linkData.linkType,
        noFollow = linkData.noFollow;
    var selected = this.isSelected();

    if (!src) {
      return null;
    }

    var classNames = (0, _classnames.default)(_constants.IMAGE_COMPONENT_CLASSNAME, ALIGNMENT_TO_CLASSNAME[alignment], {
      selected: selected
    });
    var popoverTarget = this._container ? this._container._img : undefined;
    var auth = (0, _userInfo.userInfoSync)();
    return _react.default.createElement(_EventBoundaryPopover.default, {
      autoPlacement: true,
      content: _react.default.createElement(_EditImagePopoverBranch.default // link props
      , {
        cache: cache,
        externalLink: externalLink,
        fetchFileByUrl: this.fetchFileByUrl,
        fetchPageBySlug: this.fetchPageBySlug,
        fetchPages: this.fetchPagesByTerm,
        href: href,
        noFollow: noFollow,
        onLinkTypeChange: this.handleLinkTypeChange,
        onSelectFile: this.handleOpenFilePicker,
        onUpdate: this.handleLinkDataUpdate,
        scopes: auth.user.scopes,
        showRefAndTargetControls: true,
        updateCache: updateCache,
        useNoLinkOption: true // image props
        ,
        alignment: alignment,
        altText: name,
        margin: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        },
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        onAltTextChange: this.handleAltTextChange,
        onDimensionsChange: this.handleDimensionsChange,
        onLayoutChange: this.handleAlignmentChange,
        onMarginChange: this.handleMarginChange,
        onImageRemove: this.handleRemoveImage,
        onSrcChange: this.handleOpenImagePicker,
        src: src,
        staticPrefix: (0, _staticUrl.getStaticPrefix)('rich-text-lib') // popover branch props
        ,
        linkDisplayName: linkDisplayName,
        linkType: linkType,
        onModeChange: this.handlePopoverModeChange,
        mode: popoverMode
      }),
      onCloseComplete: this.handlePopoverModeChange.bind(this, _popover.PopoverBodyMode.PREVIEW),
      open: selected,
      pinToConstraint: ['left', 'right', 'top', 'bottom'],
      placement: this.getPopoverPlacement(),
      target: popoverTarget
    }, _react.default.createElement("div", null, _react.default.createElement(_UIImage.default, {
      onLoad: this.handleImageLoad,
      alt: name,
      className: classNames,
      ref: function ref(c) {
        return _this._container = c;
      },
      responsive: false,
      onClick: this.forceSelectionOfImageBlock,
      src: src
    }), this.renderFileManager(auth)));
  }
});

var _default = (0, _withLinkCache.default)(AdvancedImage);

exports.default = _default;
module.exports = exports.default;